module.exports = __webpack_public_path__ + "img/weikaipiao.d2b4fc80.png";